import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { UPDATE_DOB } from "utils";
import { formatBirthdateForUI, disarmNonNums } from "utils/helpers";
import moment from "moment";
import { ERROR_STATUS } from "utils/constants";
import UpdateUserDetailsModal from "./UpdateUserDetailsModal";


const UpdateDOBModal = ({ user, setNewDOB, setDOBUpdated, refetch }) => {
  const [dOB, setDOB] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [docsReceived, setDocsReceived] = useState(false);
  const [updateDOB] = useMutation(UPDATE_DOB);

  const handleSubmit = async date => {
    if (!docsReceived) {
      setErrorMessage(
        "Please verify that you have recieved the necessary documents."
      );
      return;
    }
    const format = moment(date, "YYYY-MM-DD", true);

    if (!format.isValid()) {
      setErrorMessage(
        "Please use the desired format 1900-12-30, ie. yyyy-mm-dd"
      );
      return;
    }

    setLoading(true);
    const res = await updateDOB({
      variables: {
        email: user.email,
        dob: dOB
      }
    });

    const uIFormattedDOB = formatBirthdateForUI(dOB);
    const {
      data: {
        updateDOB: { status }
      }
    } = res;
    if (status === ERROR_STATUS) {
      setErrorMessage(
        "There was an error updating the date of birth. Please try again in 5 minutes. If this persists, please reach out to dev-support."
      );
      setLoading(false);
      return;
    }
    setLoading(false);
    setSuccess(true);
    setDOBUpdated(true);
    setNewDOB(uIFormattedDOB);
    refetch();
  };

  return (
    <UpdateUserDetailsModal
      label="Date of Birth"
      currentValue={user.dob}
      onSubmit={() => handleSubmit(dOB)}
      updateNewValue={setDOB}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      loading={loading}
      successMainMessage="Date of Birth has been updated to:"
      successSubMessage={`${dOB}`}
      showSuccessState={success}
      showOptionButton={true}
      optionButtonText="Documents received"
      optionButtonNewValue={docsReceived}
      optionButtonUpdateNewValue={setDocsReceived}
      optionButtonErrorClearer={() => setErrorMessage("")}
      onKeyDownValidation={e =>
        disarmNonNums(
          e,
          setErrorMessage,
          "Please only type numbers or dash.",
          ""
        )
      }
    />
  );
};

export default UpdateDOBModal;
